export default __webpack_public_path__ + "static/media/moreClose.d4c15b41.svg";